import { createApp } from 'vue';
import Uploader from './Uploader.vue';
require('./_Uploader.less');

document.addEventListener('DOMContentLoaded', () =>{
    let rootId = 'uploader';
    let rootElement = document.getElementById(rootId)

    if (rootElement) {
        let app = createApp(Uploader, {
                maxFileSize: rootElement.getAttribute('data-max-file-size'),
                uploadUrl: rootElement.getAttribute('data-upload-url'),
                i18n: {
                    COM_EVENTGALLERY_EVENT_UPLOAD_FILES_TO_UPLOAD: rootElement.getAttribute('data-i18n-COM_EVENTGALLERY_EVENT_UPLOAD_FILES_TO_UPLOAD'),
                    COM_EVENTGALLERY_EVENT_UPLOAD_PENDING: rootElement.getAttribute('data-i18n-COM_EVENTGALLERY_EVENT_UPLOAD_PENDING'),
                    COM_EVENTGALLERY_EVENT_UPLOAD_FINISHED: rootElement.getAttribute('data-i18n-COM_EVENTGALLERY_EVENT_UPLOAD_FINISHED')
                }
            }
        );
        app.mount(rootElement);
    }
});
